module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/credits-cd4e32d514928acc1b4d802042d84dfd.jpg";